import React, { useState, useEffect } from 'react';
import emailIcon from '../../../assets/icons/email.png';
import helpIcon from '../../../assets/icons/questionmark.png';
import './Help.scss';

export default function help() {
    const FAQs = [
        {
            question: 'How do I receive alerts for a Monitoring Area?',
            answer: 'To enable email alerts for a specific Monitoring Area, locate the area you want to be alerted for under the Monitoring Areas panel, and toggle the alerts button.',
            answer_2: 'Everytime a new fire or prediction is detected in that specific area, users will be alerted.'
        },
        {
            question: 'How do I receive alerts for a specific fire?',
            answer: 'To enable email alerts for a specific fire, locate the fire you want to be alerted for under the Fires panel, and toggle the alerts button.',
            answer_2: 'Everytime there is an update to that specific fire, users will be alerted.'
        },
        {
            question: 'What data is based on my current Monitoring Area?',
            answer: 'Predictions, Fires, Sensor Data (VIIRS, MODIS), RAWS',
        }
    ]
    return (
        <div className='help-page'>
            <div className='help-page-title'>
                <img className='help-page-title-icon' src={helpIcon}/>
                <div className='help-page-title-text'>Need help?</div>
            </div>
            <div className='help-page-description'>Use the contact information below to ask any questions regarding Space-Eyes FireWatch and we will assist you as as soon as possible.</div>
            <div className='help-page-contact'>
                <div className='help-page-contact-email-text'>Contact Support: </div>
                <div className='help-page-contact-email'>
                    <img src={emailIcon} className='help-page-contact-email-img'/>
                    <div className='help-page-contact-email-text'>support@space-eyes.com</div>
                </div>
            </div>
            <div className='help-page-faqs'>
            <div className='help-page-faqs-title'>Frequently Asked Questions:</div>
            <div className='help-page-faqs-container'>
                {FAQs.map((faq) => {
                    return (
                        <div className='help-page-faqs-container-faq'>
                            <div className='help-page-faqs-container-faq-question'>{faq.question}</div>
                            <div className='help-page-faqs-container-faq-answer'>{faq.answer}</div>
                            {faq.answer_2 &&  <div className='help-page-faqs-container-faq-answer'>{faq.answer_2}</div>}
                        </div>
                    )
                })}
                </div>
            </div>
        </div>
    )
}